import React, { useEffect, useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { MobileBlurImage } from 'ts/common/components/gallery/screenshot-deterrence/MobileBlur';
import useMobileBlur from 'ts/common/components/gallery/screenshot-deterrence/MobileBlurContext';

type ZoomableDetailPhotoProps = {
    imageUrl: string;
};

const fillParentStyle: React.CSSProperties = {
    height: '100%',
    width: '100%'
};

const contentStyle: React.CSSProperties = {
    ...fillParentStyle,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

const imageStyle: React.CSSProperties = {
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
    userSelect: 'none'
};

const ZoomableDetailPhoto: React.FC<ZoomableDetailPhotoProps> = ({ imageUrl }) => {
    const [isZoomed, setIsZoomed] = useState(false);
    const { blur, pressHandlers, onContextMenu } = useMobileBlur('lightbox');

    useEffect(() => {
        setIsZoomed(false);
    }, [imageUrl]);

    return (
        <TransformWrapper
            key={imageUrl}
            centerOnInit
            centerZoomedOut
            doubleClick={{ disabled: true }}
            initialScale={1}
            limitToBounds
            maxScale={5}
            minScale={1}
            onTransform={(_ref, state) => setIsZoomed(state.scale > 1)}
            panning={{ disabled: !isZoomed, velocityDisabled: true }}
            pinch={{ allowPanning: true }}
            wheel={{ disabled: true }}
        >
            {({ resetTransform, setTransform }) => (
                <div
                    data-photo-zoom
                    data-photo-zoomed={isZoomed}
                    style={fillParentStyle}
                    {...pressHandlers}
                    onDoubleClickCapture={(event) => {
                        event.stopPropagation();
                        isZoomed ? resetTransform(0) : setTransform(0, 0, 2, 0);
                    }}
                >
                    <TransformComponent wrapperStyle={fillParentStyle} contentStyle={contentStyle}>
                        <img
                            alt=""
                            data-testid="zoomable-detail-photo-image"
                            draggable={false}
                            onContextMenu={onContextMenu}
                            src={imageUrl}
                            style={imageStyle}
                        />
                        {blur && <MobileBlurImage {...blur} fit="contain" src={imageUrl} />}
                    </TransformComponent>
                </div>
            )}
        </TransformWrapper>
    );
};

export default ZoomableDetailPhoto;
